export const inIframe = () => window.top !== window.self;
